<template>
  <div v-if="hasError" class="app-alert-error app-system-alert" id="payError"
       role="alert" ref="payError">
    <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <p ref="alertMessage" tabindex="-1">{{ message }}</p>
  </div>
</template>

<script>
import _ from 'underscore'
import MESSAGES from '@/assets/_systemFeedback'

/**
 * Same look/feel as SystemAlert but better not to mix & match since payment is unique and not as common.
 */
export default {
  name: "PaymentAlert",
  props: {
    hasError: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    }
  },
  computed: {
    catchAllError() {
      // use generic catch-all message if card is supported but something else went wrong
      const err = _.find(MESSAGES, item => item.code === 35);
      return err ? err.message : 'Your payment was not successful! Please try again.';
    },
    message() {
      return (this.errorMessage.length > 0) ? this.errorMessage : this.catchAllError;
    }
  },
  updated() {
    if (this.$refs.alertMessage) {
      this.$refs.alertMessage.focus();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/system-alert";
</style>
